import React, { Component } from 'react'
import Layout from '../layouts/Layout'
import BodyTextLayout from '../layouts/BodyTextLayout'
import { withPrefix } from 'gatsby'
import LogoHeader from '../components/LogoHeader'
import abcRallyPhoto from '../images/abc-rally-photo.jpg'
import IframeResizer from 'react-iframe-resizer-super'
import DonateButton from '../components/DonateButton'

import AOS from 'aos'
import 'aos/dist/aos.css'

export default class App extends Component {
  componentDidMount() {
    AOS.init({
      once: true,
    })
  }
  render() {
    const iframeResizerOptions = {
      // log: true,
      autoResize: true,
      checkOrigin: false,
      // resizeFrom: 'parent',
      // heightCalculationMethod: 'max',
      // initCallback: () => { console.log('ready!'); },
      // resizedCallback: () => { console.log('resized!'); },
    }

    return (
      <Layout>
        <div className="header-container">
          <BodyTextLayout>
            <LogoHeader />
          </BodyTextLayout>
          <BodyTextLayout>
            <h1 class="blue h1 title" aria-label="Inside Job: Political Interference at the ABC">
              INSIDE JOB
            </h1>

            <div className="h3 light white sub-title" aria-hidden="true">
              Political Interference at the ABC
            </div>
          </BodyTextLayout>
        </div>
        <BodyTextLayout className="intro-paragraphs">
          {/* <h2 className="bold h3 orange body-header first-body-header">
            An abused <br />
            appointment system
          </h2> */}
          <p>
            Appointments to the ABC Board are supposed to be merit-based, involving an external
            recruitment agency and an independent nominations panel.
          </p>
          <p>
            <strong>
              But the Coalition has repeatedly ignored the recommendations of the panel in favour of
              handpicking their mates to board positions.{' '}
            </strong>
            Of the six current government-appointed board members, four were appointed without the
            endorsement of the nominations panel.
          </p>
          <p>
            We’ve recently witnessed the devastating consequences of this inside job. The rest of
            the Board sat on their hands while former ABC Chair Justin Milne - an old friend of
            Malcolm Turnbull -{' '}
            <strong>
              repeatedly sought to interfere in the ABC’s editorial and fire senior journalists for
              reporting that angered the Government.
            </strong>
          </p>
          <p class="h5 normal blue pull-out-quote" style={{ fontFamily: 'Inter UI' }}>
            And Prime Minister Scott Morrison has already point blank refused to rule out appointing
            yet another Coalition lackey as the new ABC Chair.
          </p>
        </BodyTextLayout>
        <BodyTextLayout data-aos="new-animation" data-aos-duration="400">
          <h2 className="bold h2 orange body-header">
            Who’s leading the <br /> current process
          </h2>
          <p>
            The Coalition hired Korn Ferry - an agency with strong ties to the Liberal party - to
            run the recruitment process for the next ABC Chair. And they did it without any
            competitive open-tender process.
          </p>
          <p>
            Their Chairperson, Katie Lahey, is a former long-serving CEO of the Business Council of
            Australia - a key political ally of the Coalition’s, and many of whose senior staff are
            former Liberal party staffers. Lahey is a regular attendee of Liberal Party functions
            and fundraisers.
          </p>
          <p>
            <b className="blue">And it gets worse.</b>
          </p>
          <img
            src={withPrefix('/img/robert-webster.png')}
            id="robert-webster"
            alt="Photo of Robert Webster"
          />
          <p>
            <strong>The man in charge of leading the process is Robert Webster</strong> - a former
            Coalition NSW MP and current Liberal party member. He has donated nearly $30,000 to the
            Liberals over the last two financial years.
          </p>
          <p>
            A former Coalition MP who still donates his own money to the Liberal party is hardly
            going to recommend anyone that a Coalition Government won’t like.
          </p>
        </BodyTextLayout>
        <div className="black-bg">
          <BodyTextLayout>
            <div className="under-spotlight-img-container">
              <img
                src={withPrefix('/img/greg-hywood-abc-composite.png')}
                className="under-spotlight-img"
                data-aos="new-light-bulb"
              />
              <img
                src={withPrefix('/img/greg-hywood-abc-silouette.png')}
                className="under-spotlight-img silouette"
              />
            </div>
            <h2 className="bold h2 orange body-header under-spotlight-header">
              Under the spotlight <br />
              Greg Hywood
            </h2>
            <p>
              The current leading candidate to be the next ABC Chair is Greg Hywood, the former CEO
              who decimated Fairfax newsrooms.
            </p>
            <p>
              Hywood fired 3600 people through five rounds of brutal redundancies over a six year
              period. He helped orchestrate the controversial Nine-Fairfax merger that has put the
              masthead’s editorial independence at risk, and already cost 92 people their jobs –
              allowing him to collect up to an $8.2 million payout.
            </p>
            <p>
              And he is no champion of public broadcasting. He repeatedly advocated for the ABC’s
              operations to be gutted and reduced to nothing more than a market failure service.
            </p>
          </BodyTextLayout>
        </div>
        <BodyTextLayout>
          <h2
            className="bold h2 orange body-header"
            data-aos="new-animation"
            data-aos-duration="400"
          >
            The current board
          </h2>
          <div className="two-col-grid">
            <div
              className="board-item"
              data-aos="new-animation"
              data-aos-duration="400"
              data-aos-delay="200"
            >
              <img src={withPrefix('/img/donny-walford.png')} className="board-profile" />
              <h3 className="blue bold h5">Donny Walford</h3>
              <ul>
                <li>
                  Didn’t apply to be on the Board. The nominations panel had never seen her, she
                  didn’t fill out an application form, and she didn’t even express any interest in
                  the job.
                </li>
                <li>
                  As recently as October 2018 was attending Liberal Party fundraisers and giving
                  them money.
                </li>
              </ul>
            </div>
            <div
              className="board-item"
              data-aos="new-animation"
              data-aos-duration="400"
              data-aos-delay="400"
            >
              <img src={withPrefix('/img/guthrie.png')} className="board-profile" />
              <h3 className="blue bold h5">Vanessa Guthrie</h3>
              <ul>
                <li>
                  A coal lobbyist, Guthrie sits on the board of two fossil fuel companies that are
                  major Coalition donors - including being CEO of the Minerals Council of Australia
                </li>
                <li>
                  Rejected by the nominations panel for having zero media experience or any other
                  relevant qualifications.
                </li>
              </ul>
            </div>
            <div
              className="board-item"
              data-aos="new-animation"
              data-aos-duration="400"
              data-aos-delay="200"
            >
              <img src={withPrefix('/img/joseph-gersh.png')} className="board-profile" />
              <h3 className="blue bold h5">Joseph Gersh</h3>
              <ul>
                <li>An investment banker who was rejected by the nominations panel</li>
                <li>
                  Gersh is a long term friend and confidante of former Liberal Treasurer Peter
                  Costello, who has previously appointed him to other board positions
                </li>
              </ul>
            </div>
            <div
              className="board-item"
              data-aos="new-animation"
              data-aos-duration="400"
              data-aos-delay="400"
            >
              <img src={withPrefix('/img/kirstin.png')} className="board-profile" />
              <h3 className="blue bold h5">Kirstin Ferguson</h3>
              <ul>
                <li>
                  Withdrew from the application process before Government personally appealed to her
                  to accept a position
                </li>
                <li>
                  Another former mining executive, infamous for failing to protect a whistleblower
                  who personally alerted her to a bribery scandal over a multi-billion dollar coal
                  deal.
                </li>
              </ul>
            </div>
          </div>
        </BodyTextLayout>
        <div className="cta-container">
          <div className="row align-center">
            <div className="small-12 medium-10 columns">
              <h2 className="bold h2 orange body-header">
                How can we protect our ABC’s independence?
              </h2>
            </div>
            <div className="small-12 medium-5 columns">
              <p>
                ABC Board directors should be champions of public broadcasting who uphold its
                independence and value its public ownership - not government cronies.
              </p>
              <p>
                {' '}
                Together we can ensure that all future appointments are truly independent of
                Government. Here’s what we need to do:
              </p>
              <ol>
                <li>
                  <b>Ensure the integrity of the process:</b> remove the ability of the Minister to
                  handpick board members unilaterally.
                </li>
                <li>
                  <b>Depoliticise the nominations:</b> replace the nominations panel with a
                  genuinely cross-party committee
                </li>
                <li>
                  <b>Increase transparency:</b> publicly publishing all positions, selection
                  criteria, and the names of nominated candidates.
                </li>
                <li>
                  <b>Give key stakeholders a voice:</b> Replace two government-appointed directors
                  with a second staff elected director and an audience supported director.
                </li>
              </ol>
            </div>
            <div className="small-12 medium-5 columns">
              <IframeResizer
                iframeResizerOptions={iframeResizerOptions}
                src="https://www.getup.org.au/campaigns/media/inside-job-political-interference-at-our-abc/inside-job-political-interference-at-our-abc"
              />
            </div>
          </div>
          <div class="row align-center">
            <div className="small-12 medium-10 columns">
              <div className="cta-wrapper">
                <p>
                  This website was made possible by the{' '}
                  <strong>6,195 incredible GetUp members</strong> that chipped in to fund
                  hard-hitting research to expose Morrison’s sham selection process for the next ABC
                  Chair and protect our ABC’s independence from further political interference.
                </p>
                <p>
                  <a
                    href="http://www.getup.org.au/abc-insidejob"
                    target="_blank"
                    style={{ color: 'white', textDecoration: 'underline' }}
                  >
                    Follow this link
                  </a>{' '}
                  to see the full Inside Job report.
                </p>
                <hr style={{ opacity: '0.4', borderColor: 'white' }} />
                <p>
                  We’re going to show the Coalition that any attempt to corrupt our ABC’s
                  independence will cost them on election day.{' '}
                </p>
                <p>
                  <b>
                    But we can’t do it without your help. Can you chip in now to fund the campaign
                    to Save our ABC?
                  </b>{' '}
                  <br />
                  <DonateButton buttonText="Donate" className="btn-secondary mt-3" />
                </p>
              </div>
            </div>
          </div>
          <div className="row expanded collapse align-center">
            <div className="small-12 columns">
              <div className="donate-container">
                <img src={abcRallyPhoto} id="abc-rally-photo" />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
